import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["label", "disabled", "dashboard", "tooltipMessage", "trackingProperties", "appUsageTracker", "isImprovedDBFilterOptIn"];
import ActionButton from '../ActionButton';
// @ts-expect-error untyped module
import useEmailDashboardProblem from './useEmailDashboardProblem';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useTracker } from '../../utils/hooks/useTracker';
import { EVENTS } from '../../utils/usageTracker';
// @ts-expect-error untyped module
import { useShowDialog } from '../../dialog/ducks';
import { EMAIL_DASHBOARD_DIALOG } from '../../dialog/dialogTypes';
// @ts-expect-error untyped module
import { useUserRoleForDashboard } from '../../utils/trackingUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_LABEL = /*#__PURE__*/_jsx(FormattedMessage, {
  message: "reporting-action-components.actions.emailReport.button.dashboardText"
});
const EmailDashboardButton = props => {
  const {
      label = DEFAULT_LABEL,
      disabled: isDisabledViaParentApp = false,
      dashboard,
      tooltipMessage: appDefinedTooltip,
      trackingProperties,
      appUsageTracker,
      isImprovedDBFilterOptIn = false
    } = props,
    buttonProps = _objectWithoutPropertiesLoose(props, _excluded);
  const usageTracker = useTracker(appUsageTracker);
  const {
    problem,
    disabledMessage
  } = useEmailDashboardProblem({
    dashboard
  });
  const showDialog = useShowDialog();
  const userRole = useUserRoleForDashboard(dashboard);
  const handleClickEmailAsset = () => {
    if (usageTracker) {
      usageTracker.track(EVENTS.clickShareAsset, {
        actionType: 'share',
        action: 'email',
        assetType: 'dashboard',
        role: userRole,
        interactionSource: trackingProperties.interactionSource
      });
    }
    showDialog({
      dialogType: EMAIL_DASHBOARD_DIALOG,
      dialogProps: {
        appUsageTracker,
        dashboard,
        isImprovedDBFilterOptIn
      }
    });
  };
  const disabled = isDisabledViaParentApp || !!problem;
  return /*#__PURE__*/_jsx(ActionButton, Object.assign({
    label: label,
    disabled: disabled,
    onClick: handleClickEmailAsset,
    tooltip: appDefinedTooltip || disabledMessage,
    dataTestId: "dashboard-action-email-dashboard"
  }, buttonProps));
};
export default EmailDashboardButton;